// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tq-0";
export var checkoutRateBadgeLink = "_tq-1";